import React, { ReactElement } from 'react';
import Svg, { G, Path } from 'react-native-svg';

import { IconStyles } from 'components/icons/types';

export const DaylightHeader = ({
  size,
  style,
}: {
  size: number;
  style: IconStyles;
}): ReactElement => {
  return (
    <Svg width={size} height={size} fill="none" style={style}>
      <G>
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 23.8533C-6.60118e-08 20.7209 0.616984 17.6191 1.81573 14.7251C3.01447 11.831 4.77149 9.20147 6.98648 6.98648C9.20147 4.77149 11.831 3.01447 14.7251 1.81573C17.6191 0.616986 20.7209 0 23.8533 0C26.9858 0 30.0876 0.616986 32.9816 1.81573C35.8756 3.01447 38.5052 4.77149 40.7202 6.98648C42.9352 9.20147 44.6922 11.831 45.8909 14.7251C47.0897 17.6191 47.7067 20.7209 47.7067 23.8533H0Z"
          fill="#FF754F"
        />
      </G>
    </Svg>
  );
};
